import { render, staticRenderFns } from "./UnionsPage.vue?vue&type=template&id=16789868&"
import script from "./UnionsPage.vue?vue&type=script&lang=js&"
export * from "./UnionsPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports